const secondsToDisplayWarning = 60;

export const remainingSessionLifetime = (idleSecondsUntilSessionExpiry, maxSessionLifetimeLeftSecs) => {
  if (maxSessionLifetimeLeftSecs <= 60) {
    // User's session has almost reached max length and cannot be extended
    return {
      checkSessionExpiryAfterSecs: maxSessionLifetimeLeftSecs + 1, // hit the api to realize the user has been logged out
      isSessionExpiring: true,
      isSessionLifeExtendable: false
    };
  } else if (idleSecondsUntilSessionExpiry <= secondsToDisplayWarning)  {
    // User's session is close to expiring due to idle time, display modal to allow session extension
    return  {
      checkSessionExpiryAfterSecs: 15, // check if the user has updated the activity in some other tabs
      isSessionExpiring: true,
      isSessionLifeExtendable: true
    };
  } else {
    // User's session is not going to expire soon, update the time when the api needs to trigger next, do not display modal
    return  {
      checkSessionExpiryAfterSecs:
          Math.min(
              maxSessionLifetimeLeftSecs - secondsToDisplayWarning,
              idleSecondsUntilSessionExpiry - secondsToDisplayWarning),
      isSessionExpiring: false,
      isSessionLifeExtendable: false
    };
  }
}
